export { default as Footer } from './Footer/Footer'
export { default as Header } from './Header'
export { default as Layout } from './Layout'
export { default as LandingPagesLayout } from './LandingPagesLayout'
export { default as MegaMenu } from './MegaMenu/MegaMenu'
